import { uniq } from 'lodash-es';
import { EQuestionType } from '../models/questionnaire';
export const getQuestionnaireLevel = (questions = [], startQuestionId, type) => {
    const nodes = questions;
    const results = {};
    let levels = 1;
    const startNode = nodes.find((node) => node.id === startQuestionId) || {};
    const traverseNode = (node, level) => {
        if (!node)
            return;
        const linkedAnswers = (node.answers?.filter((ans) => ans.nextQuestionId) || []).map((ans) => ans?.nextQuestionId);
        const linkedAnswerIds = uniq(linkedAnswers);
        const { id: questionId } = node;
        results[questionId] = Math.max(results[questionId] || 0, level);
        levels = Math.max(levels || 1, level);
        if (node.type === EQuestionType.LeadGeneration || !linkedAnswerIds.length) {
            return;
        }
        linkedAnswerIds.forEach((answerId) => {
            const nextNode = nodes.find((node) => node.id === answerId);
            if (nextNode) {
                traverseNode(nextNode, level + 1);
            }
        });
    };
    traverseNode(startNode, 1);
    if (type === 'level') {
        return levels;
    }
    else {
        return results;
    }
};
